import { render } from "./TabsContent.vue?vue&type=template&id=936b7e70&scoped=true"
import script from "./TabsContent.vue?vue&type=script&lang=js"
export * from "./TabsContent.vue?vue&type=script&lang=js"

import "./TabsContent.vue?vue&type=style&index=0&id=936b7e70&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936b7e70"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QIcon});
